module.exports = "<iframe [src]=\"url\" class=\"asp-iframe\" onload=\"window.parent.scrollTo(0,0);\"></iframe>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/pregled-faktura/pregled-faktura.component.html
// module id = ./src/app/pages/pregled-faktura/pregled-faktura.component.html
// module chunks = main